var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCabinet = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10 .992c-5.522 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10Zm0 2.99a3.308 3.308 0 1 1 0 6.615 3.308 3.308 0 0 1 0-6.615ZM5.219 16.615a7.339 7.339 0 0 0 4.779 1.762 7.337 7.337 0 0 0 4.78-1.763c.313-.267.493-.659.493-1.07a3.331 3.331 0 0 0-3.346-3.335H8.076a3.336 3.336 0 0 0-3.352 3.334c0 .412.181.804.495 1.072Z",
  clipRule: "evenodd"
})));
export default SvgCabinet;